import React from 'react';
import PropTypes from 'prop-types';
import ButtonGroup from '@mui/material/ButtonGroup';
import { FormHelperText } from '@mui/material';
import { Controller } from 'react-hook-form';

const UiButtonGroup = ({ children, name, control, ...restProps }) => {
  if (control) {
    return (
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState: { error } }) => (
          <>
            <ButtonGroup {...field} {...restProps}>
              {children}
            </ButtonGroup>
            {error && <FormHelperText>{error.message}</FormHelperText>}
          </>
        )}
      />
    );
  }

  return <ButtonGroup {...restProps}>{children}</ButtonGroup>;
};

UiButtonGroup.propTypes = {
  children: PropTypes.node,
  control: PropTypes.object,
  name: PropTypes.string,
};

export default UiButtonGroup;
